<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";
import AppLayout from "@/Layouts/AppLayout.vue";

defineProps({
    canResendVerification: Boolean,
});

const form = useForm({});

const resend = () => {
    form.post(route("verification.send"));
};
</script>

<template>
    <Head>
        <title>Link expired | Gift Hero</title>
        <meta name="robots" content="noindex" />
    </Head>
    <AppLayout>
        <div
            class="container-wide stacked-children whitespace-bottom whitespace-top"
        >
            <div data-layout="module" data-layout-options="gutters wrap-items">
                <div
                    data-layout="module__item"
                    data-layout-width="one-whole c-one-quarter"
                >
                    <div class="copy-block"></div>
                </div>
                <div
                    data-layout="module__item"
                    data-layout-width="one-whole c-one-half"
                >
                    <div class="copy-block">
                        <h1>This link has expired</h1>
                        <p>
                            The link you followed is no longer valid. It may
                            have expired, or it may have been changed since it
                            was created.
                        </p>
                        <template v-if="canResendVerification">
                            <p>
                                To verify your email address, request a new
                                verification email and click the link inside it.
                            </p>
                            <p>
                                <button
                                    class="button is-primary is-rounded is-bold has-shadow"
                                    :disabled="form.processing"
                                    @click="resend"
                                >
                                    Send a New Verification Email
                                </button>
                            </p>
                        </template>
                        <p v-else>
                            <Link
                                href="/"
                                class="button is-primary is-rounded is-bold has-shadow"
                            >
                                Return to Gift Hero
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
